import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SectionTabs, { SectionTab } from '../components/SectionTabs';
import { PageHeader } from '../components/ui';
import Aging from './Aging';
import AgingMaintenance from './AgingMaintenance';

const AGING_TABS: SectionTab[] = [
  { id: 'aging', label: 'Aging' },
  { id: 'maintenance', label: 'Aging Maintenance' }
];

const AgingSection: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const current = searchParams.get('tab');
  const activeTab = current === 'maintenance' ? 'maintenance' : 'aging';

  const handleTabChange = (id: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', id);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="space-y-7">
      <PageHeader
        title="Aging"
        subtitle="Track long-term aging alongside detailed maintenance logs."
      />

      <SectionTabs
        tabs={AGING_TABS}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {/* Mount both subtabs; refetch when tab becomes visible */}
      <div>
        <div hidden={activeTab !== 'aging'}>
          <Aging tabVisible={activeTab === 'aging'} />
        </div>
        <div hidden={activeTab !== 'maintenance'}>
          <AgingMaintenance tabVisible={activeTab === 'maintenance'} />
        </div>
      </div>
    </div>
  );
};

export default AgingSection;


